/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { AutomationApi } from '../api/automation.api';
// import { InvertersData, InvertersValue, ActivePowerValue } from '../../../interfaces/solar/inverters';
import { AutomationData, AutomationValue } from '../../../interfaces/solar/automation';

@Injectable()
export class AutomationService extends AutomationData {

  constructor(private api: AutomationApi) {
    super();
  }

  getAutomationControllerData(params): Observable<AutomationValue[]> {
    return this.api.getAutomationController(params);
  }

  getAutomationControllersData(params): Observable<AutomationValue[]> {
    return this.api.getAutomationsController(params);
  }
  // getInverterTodayData(params): Observable<InvertersValue[]> {
  //   return this.api.getInverterTodayData(params);
  // }

  // // Pac - Active Power
  // getTodayInvertersPacByKtpNum(params): Observable<InvertersValue[]> {
  //   return this.api.getTodayInvertersPacByKtpNum(params);
  // }

  // // Qac - Reactive Power
  // getTodayInvertersQacByKtpNum(params): Observable<InvertersValue[]> {
  //   return this.api.getTodayInvertersQacByKtpNum(params);
  // }

  // // Current Power
  // getCurrentPower(params): Observable<string> {
  //   return this.api.getCurrentPower(params);
  // }

  // getDailyEnergy(params): Observable<string> {
  //   return this.api.getDailyEnergy(params);
  // }

  // // Array of day PV Power
  // getDayPowerValues(params): Observable<ActivePowerValue[]> {
  //   return this.api.getDayPowerValues(params);
  // }

  // // Array of day SOLING Power
  // getDaySolingPowerValues(params): Observable<ActivePowerValue[]> {
  //   return this.api.getDaySolingPowerValues(params);
  // }



  // list(): Observable<Facility[]> {
  //   // return this.api.list();
  //   return observableOf(this.data);
  // }
}
